import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';

import Head from '../../components/Partials/Head/Head';
import Auxiliary from '../../hoc/Auxiliary';
import TextGroup from '../../components/TextGroup/TextGroup';
import ProductBanner from '../../components/ProductBanner/ProductBanner';
import ProductSection from '../../components/ProductSection/ProductSection';
class Otm extends Component {

  render() {
    return (
      <Auxiliary>
        <Head {...this.props} id="otm" />
        <ProductBanner imgPadding {...this.props} page="otm" />
        <ProductSection noPadBottom {...this.props} page="otm" section="features">
          <TextGroup {...this.props} page="otm" section="features" />
        </ProductSection>
        <ProductSection {...this.props} page="otm" section="why_choose">
          <TextGroup {...this.props} page="otm" section="why_choose" />
          <TextGroup noPadBottom {...this.props} page="otm" section="demo" />
        </ProductSection>
      </Auxiliary>
    )
  }
}

export default withTranslation()(Otm);